import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import { useTranslation } from 'react-i18next';

const STATUS_CONFIG = {
  'Operational': {
    icon: CheckCircleIcon,
    color: '#4caf50',
  },
  'In Progress': {
    icon: WarningIcon,
    color: '#ff9800',
  },
  'Attention Required': {
    icon: ErrorIcon,
    color: '#f44336',
  },
};

const STATUS_KEYS = {
  'Operational': 'shared.status.operational',
  'In Progress': 'shared.status.inProgress',
  'Attention Required': 'shared.status.attentionRequired',
};

/**
 * StatusIndicator - Displays status with icon and optional label
 * @param {string} status - Status (Operational, In Progress, Attention Required)
 * @param {boolean} showLabel - Whether to show the text label
 */
export const StatusIndicator = ({ status, showLabel = true }) => {
  const { t } = useTranslation('transparency');
  const config = STATUS_CONFIG[status] || STATUS_CONFIG['In Progress'];
  const Icon = config.icon;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Icon sx={{ color: config.color, fontSize: 20 }} />
      {showLabel && (
        <Typography variant="body2" color="text.secondary">
          {t(STATUS_KEYS[status] ?? STATUS_KEYS['In Progress'])}
        </Typography>
      )}
    </Box>
  );
};
